import { useCallback, useEffect } from "react";
import type { useRpcChannels } from "../main";

const FULLSCREEN_CLASS = "fullscreen__sketch";

export function useFullscreen(channels: ReturnType<typeof useRpcChannels>) {
  const toggleFullscreen = useCallback(async () => {
    try {
      if (document.fullscreenElement) {
        await document.exitFullscreen();
        return;
      }
      await document.documentElement.requestFullscreen();
    } catch (error) {
      console.warn("Native prototype fullscreen failed", error);
    }
  }, []);

  useEffect(() => {
    const syncFullscreenMode = () => {
      const isFullscreen =
        document.fullscreenElement === document.documentElement;
      document.documentElement.classList.toggle(FULLSCREEN_CLASS, isFullscreen);
      void channels.core.methods?.notifyFullscreenChanged?.(isFullscreen);
    };

    document.addEventListener("fullscreenchange", syncFullscreenMode);
    syncFullscreenMode();
    return () => {
      document.removeEventListener("fullscreenchange", syncFullscreenMode);
    };
  }, [channels]);

  return { toggleFullscreen };
}
